const numberWithCommas = (x) => {
  x = x.toString();
  var afterPoint = "";
  if (x.indexOf(".") > 0) afterPoint = x.substring(x.indexOf("."), x.length);
  x = Math.floor(x);
  x = x.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  var res =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  return res;
};

const roundOffTwoDecimal = (x) => {
  x = Math.abs(x);
  x = x.toFixed(2);
  return x;
};
const roundOffSixDecimal = (x) => {
  x = Math.abs(x);
  x = x.toFixed(6);
  return x;
};
const arraySortAscending = (x) => {
  x.sort((a, b) => {
    return a.price_change_percentage_24h - b.price_change_percentage_24h;
  });
};

const arraySortDescending = (x) => {
  let y = x.sort((a, b) => {
    return a.price_change_percentage_24h - b.price_change_percentage_24h;
  });
  return y.reverse();
};

const arraySortPriceAscending = (x) => {
  x.sort((a, b) => {
    return a.current_price - b.current_price;
  });
  return x;
};

const arraySortPriceDescending = (x) => {
  let y = x.sort((a, b) => {
    return a.current_price - b.current_price;
  });
  return y.reverse();
};

const getDateFormat = (x) => {
  var dd = x.getDate();

  var mm = x.getMonth() + 1;
  var yyyy = x.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "-" + mm + "-" + yyyy;
};

const allCurrency = [
  "aed",
  "ars",
  "aud",
  "bch",
  "bdt",
  "bhd",
  "bits",
  "bmd",
  "bnb",
  "brl",
  "btc",
  "cad",
  "chf",
  "clp",
  "cny",
  "czk",
  "dkk",
  "dot",
  "eos",
  "eth",
  "eur",
  "gbp",
  "hkd",
  "huf",
  "idr",
  "ils",
  "inr",
  "jpy",
  "krw",
  "kwd",
  "link",
  "lkr",
  "ltc",
  "mmk",
  "mxn",
  "myr",
  "ngn",
  "nok",
  "nzd",
  "php",
  "pkr",
  "pln",
  "rub",
  "sar",
  "sats",
  "sek",
  "sgd",
  "thb",
  "twd",
  "uah",
  "usd",
  "vef",
  "vnd",
  "xag",
  "xau",
  "xdr",
  "xlm",
  "xrp",
  "yfi",
  "zar",
];

const getDate = (x) => {
  var date = x.getDate();
  var month = x.getMonth();
  var year = x.getFullYear();
  return date + "-" + month + "-" + year;
};
export {
  numberWithCommas,
  roundOffTwoDecimal,
  arraySortAscending,
  arraySortDescending,
  arraySortPriceAscending,
  arraySortPriceDescending,
  getDateFormat,
  allCurrency,
  getDate,
  roundOffSixDecimal
};
